import { Spinner } from "@/components/General/Spinner/spinner.component";

import { useDefaultHook } from "../helpers/useDefault.hook";
import { PaymentAddressPartial } from "../partials/paymentAddress";

const PaymentBusinessAddress = () => {
    const { loading } = useDefaultHook();

    if (loading) {
        return <Spinner />;
    }

    return <PaymentAddressPartial />;
};

export { PaymentBusinessAddress };
